export default function LocalDelivery() {
  const deliveryFeatures = [
    {
      icon: 'ri-truck-line',
      title: 'Free Delivery',
      description: 'Orders over $50 in Kalamazoo & Grand Rapids'
    },
    {
      icon: 'ri-time-line',
      title: 'Fast Service',
      description: 'Same-day or next-day delivery available'
    },
    {
      icon: 'ri-heart-line',
      title: 'Community First',
      description: 'Supporting locals who need convenient access'
    }
  ];

  return (
    <section className="py-32 px-8 bg-[#181818] border-t border-b border-[#333333]">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 border border-white/20 rounded-full px-5 py-2 mb-8">
            <span className="text-xs font-bold text-white tracking-wide">LOCAL SERVICE</span>
          </div>

          <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-[0.95] tracking-tight mb-8">
            Kalamazoo &<br />
            Grand Rapids<br />
            <span className="bg-gradient-to-r from-white via-gray-200 to-white bg-clip-text text-transparent">We Deliver</span>
          </h2>

          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            No transportation? No problem. We bring BillPlay directly to your door because accessibility matters.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {deliveryFeatures.map((feature, index) => (
            <div 
              key={index}
              className="bg-[#0A0A0A] border border-[#333333] rounded-2xl p-8 text-center hover:border-white/30 transition-all duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center mx-auto mb-6">
                <i className={`${feature.icon} text-4xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-black text-white mb-3">
                {feature.title}
              </h3>
              
              <p className="text-base text-gray-400 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-lg text-gray-300 mb-6">
            Questions about local delivery? Reach out.
          </p>
          <a 
            href="tel:269-993-2813"
            className="inline-block bg-white text-black px-10 py-4 rounded-lg font-black text-sm hover:scale-105 transition-all duration-300 whitespace-nowrap"
          >
            CALL 269-993-2813
          </a>
        </div>
      </div>
    </section>
  );
}